import { render } from "./Deliverables.vue?vue&type=template&id=12887982"
import script from "./Deliverables.vue?vue&type=script&lang=js"
export * from "./Deliverables.vue?vue&type=script&lang=js"

import "./Deliverables.vue?vue&type=style&index=0&id=12887982&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__